/**
 * TID — Main JavaScript
 * Vendor-free, native JS.
 * jQuery is NOT required — Bitrix loads it itself when needed.
 */

// Script loads at the bottom of <body>, so DOM is already available.
// Use a safe wrapper that works even if DOMContentLoaded already fired.
function tidReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

tidReady(function() {

  // ════════════════════════════════════════════════════════
  // DNS-style Mega Menu (hover sidebar → show panel)
  // ════════════════════════════════════════════════════════
  const catalogToggle = document.querySelector('[data-role="tid-catalog-toggle"]');
  const catalogDropdown = document.querySelector('[data-role="tid-catalog-dropdown"]');

  if (catalogToggle && catalogDropdown) {
    // ── Hover logic for sidebar root items ──
    const rootItems = catalogDropdown.querySelectorAll('[data-role="tid-megamenu-root"]');
    const panels = catalogDropdown.querySelectorAll('[data-role="tid-megamenu-panel"]');

    function activateSection(sectionId) {
      // Update root items
      rootItems.forEach(function(item) {
        item.classList.toggle(
          'tid-megamenu__root-item--active',
          String(item.dataset.sectionId) === String(sectionId)
        );
      });

      // Update panels
      panels.forEach(function(panel) {
        panel.classList.toggle(
          'tid-megamenu__panel--active',
          String(panel.dataset.parentId) === String(sectionId)
        );
      });
    }

    // On hover over a root item → activate its panel
    rootItems.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        const sectionId = this.dataset.sectionId;
        if (sectionId) {
          activateSection(sectionId);
        }
      });
    });

    // Activate first root item by default (if none active)
    var activeRoot = catalogDropdown.querySelector('.tid-megamenu__root-item--active');
    if (!activeRoot && rootItems.length > 0) {
      activateSection(rootItems[0].dataset.sectionId);
    }

    // ── Click toggle (open/close) ──
    catalogToggle.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = catalogDropdown.classList.contains('tid-header__catalog-dropdown--open');

      if (!isOpen) {
        catalogDropdown.classList.add('tid-header__catalog-dropdown--open');
        catalogToggle.classList.add('tid-header__catalog-btn--active');

        // Reset to first section when opening
        if (rootItems.length > 0) {
          activateSection(rootItems[0].dataset.sectionId);
        }
      } else {
        catalogDropdown.classList.remove('tid-header__catalog-dropdown--open');
        catalogToggle.classList.remove('tid-header__catalog-btn--active');
      }
    });

    // ── Close on click outside ──
    document.addEventListener('click', function(e) {
      if (catalogDropdown.classList.contains('tid-header__catalog-dropdown--open') &&
          !catalogToggle.contains(e.target) &&
          !catalogDropdown.contains(e.target)) {
        catalogDropdown.classList.remove('tid-header__catalog-dropdown--open');
        catalogToggle.classList.remove('tid-header__catalog-btn--active');
      }
    });

    // ── Close on Escape ──
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && catalogDropdown.classList.contains('tid-header__catalog-dropdown--open')) {
        catalogDropdown.classList.remove('tid-header__catalog-dropdown--open');
        catalogToggle.classList.remove('tid-header__catalog-btn--active');
      }
    });
  }

  // ════════════════════════════════════════════════════════

  // ── Cart count sync (from hidden BitrixSmallCart to visible static icon) ──
  function tidSyncCartCount() {
    var visibleBadge = document.getElementById('tid-cart-count');
    var hiddenCart = document.querySelector('[data-role="tid-hidden-cart"]');

    if (!visibleBadge || !hiddenCart) {
      // Retry in case DOM isn't ready yet
      setTimeout(tidSyncCartCount, 500);
      return;
    }

    // Try to get count from the hidden BitrixSmallCart component
    var hiddenBadge = hiddenCart.querySelector('.tid-header-action__count');
    if (hiddenBadge) {
      var count = parseInt(hiddenBadge.textContent) || 0;
      if (count > 0) {
        visibleBadge.textContent = count;
        visibleBadge.style.display = '';
      } else {
        visibleBadge.style.display = 'none';
      }
    }
  }

  // Initial sync (retries every 500ms until DOM is ready)
  setTimeout(tidSyncCartCount, 500);

  // Re-sync after BitrixSmallCart updates (interval fallback)
  setInterval(tidSyncCartCount, 3000);

  // ── Mobile menu (burger) ──
  // (handled via BX.ready in footer.php for Bitrix compatibility)

  // ── Quantity input ──
  document.querySelectorAll('.tid-quantity').forEach(function(qty) {
    const input = qty.querySelector('.tid-quantity__input');
    const minus = qty.querySelector('.tid-quantity__btn--minus');
    const plus = qty.querySelector('.tid-quantity__btn--plus');

    if (!input || !minus || !plus) return;

    minus.addEventListener('click', function() {
      let val = parseInt(input.value) || 1;
      if (val > 1) {
        input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    plus.addEventListener('click', function() {
      let val = parseInt(input.value) || 1;
      let max = parseInt(input.getAttribute('max')) || 999;
      if (val < max) {
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    input.addEventListener('input', function() {
      let val = parseInt(this.value) || 1;
      let max = parseInt(this.getAttribute('max')) || 999;
      let min = parseInt(this.getAttribute('min')) || 1;
      if (val < min) this.value = min;
      if (val > max) this.value = max;
    });
  });

  // ── Product gallery thumbs ──
  const galleryMain = document.querySelector('.tid-product-gallery__main img');
  const thumbs = document.querySelectorAll('.tid-product-gallery__thumb');

  if (galleryMain && thumbs.length) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Читаем full-ссылку из data-image на кнопке, иначе из src вложенного img
        var thumbImg = this.querySelector('img');
        var fullSrc = this.dataset.image || (thumbImg ? thumbImg.src : '');
        if (!fullSrc) return;

        // Update main image
        galleryMain.src = fullSrc;
        galleryMain.alt = this.querySelector('img')?.alt || '';

        // Update active state
        thumbs.forEach(function(t) {
          t.classList.remove('tid-product-gallery__thumb--active');
        });
        this.classList.add('tid-product-gallery__thumb--active');
      });
    });
  }

  // ── Product tabs (catalog.element detail page) ──
  // Template classes: tid-product-tabs__nav, tid-product-tabs__item, tid-product-tabs__pane
  const tabNav = document.querySelector('.tid-product-tabs__nav, .tid-product-info__tabs-nav');
  const tabPanes = document.querySelectorAll('.tid-product-tabs__pane, .tid-product-info__tab-content');

  if (tabNav) {
    tabNav.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-role="tab"], .tid-product-info__tab-btn');
      if (!btn) return;

      const targetId = btn.dataset.tab;
      if (!targetId) return;

      // Update tab items
      tabNav.querySelectorAll('[data-role="tab"], .tid-product-info__tab-btn').forEach(function(b) {
        b.classList.remove('active', 'tid-product-info__tab-btn--active');
      });
      btn.classList.add('active', 'tid-product-info__tab-btn--active');

      // Update content panes
      tabPanes.forEach(function(pane) {
        const paneTab = pane.dataset.tab || pane.id;
        pane.classList.remove('active', 'tid-product-info__tab-content--active');
        if (paneTab === targetId) {
          pane.classList.add('active', 'tid-product-info__tab-content--active');
        }
      });
    });
  }

  // ── Fixed header on scroll ──
  const header = document.querySelector('.tid-header');
  if (header) {
    let lastScroll = 0;

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        header.classList.add('tid-header--scrolled');
      } else {
        header.classList.remove('tid-header--scrolled');
      }

      // Hide on scroll down, show on scroll up
      if (currentScroll > lastScroll && currentScroll > 200) {
        header.classList.add('tid-header--hidden');
      } else {
        header.classList.remove('tid-header--hidden');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ── Lazy loading for images (native) ──
  if ('loading' in HTMLImageElement.prototype) {
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.src = img.dataset.src || img.src;
    });
  }

  // ════════════════════════════════════════════════════════
  // Add to Cart (AJAX — detail page & section cards)
  // ════════════════════════════════════════════════════════
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-role="add-to-cart"]');
    if (!btn) return;
    e.preventDefault();

    var productId = btn.dataset.id;
    if (!productId) return;

    // Найти quantity input в этом же блоке
    var qtyBlock = btn.closest('.tid-product-info__buy-block') ||
                   btn.closest('.tid-product-card__buy') ||
                   btn.closest('[data-entity="item"]');
    var qtyInput = qtyBlock
      ? qtyBlock.querySelector('[data-role="quantity-input"], .tid-quantity__input')
      : null;
    var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : parseInt(btn.dataset.quantity) || 1;

    // Блокируем кнопку на время запроса
    btn.disabled = true;
    var originalText = btn.innerHTML;
    btn.innerHTML = '<span class="tid-spinner"></span>';

    var postData = {
      id: productId,
      quantity: quantity,
      sessid: BX.message('bitrix_sessid') || ''
    };

    BX.ajax.post(
      '/ajax/add_to_cart.php',
      postData,
      function(result) {
        btn.disabled = false;
        btn.innerHTML = originalText;

        try {
          var data = JSON.parse(result);
          if (data.success) {
            // Мгновенно обновляем счётчик корзины из ответа
            if (data.cart_count !== undefined) {
              var countEl = document.getElementById('tid-cart-count');
              if (countEl) {
                var count = parseInt(data.cart_count);
                if (count > 0) {
                  countEl.textContent = count;
                  countEl.style.display = '';
                } else {
                  countEl.style.display = 'none';
                }
              }
            }
            // Также триггерим штатное обновление BitrixSmallCart
            BX.onCustomEvent('OnBasketChange');
            // Показываем уведомление
            if (window.tidNotification) {
              tidNotification.show(data.message || 'Товар добавлен в заказ');
            }
          } else {
            if (window.tidNotification) {
              tidNotification.show(data.message || 'Ошибка добавления в заказ');
            }
          }
        } catch(e) {
          if (window.tidNotification) {
            tidNotification.show('Ошибка добавления в заказ');
          }
        }
      }
    );
  });

  // ════════════════════════════════════════════════════════
  // Add to Compare (AJAX)
  // ════════════════════════════════════════════════════════
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-role="add-to-compare"]');
    if (!btn) return;
    e.preventDefault();

    var productId = btn.dataset.id;
    if (!productId) return;

    btn.disabled = true;

    BX.ajax.post(
      window.location.href,
      {
        action: 'ADD_TO_COMPARE_LIST',
        id: productId,
        ajax_basket: 'Y'
      },
      function(result) {
        btn.disabled = false;

        // Добавляем визуальный фидбек
        btn.classList.add('tid-product-info__action--active', 'tid-product-card__action--active');

        if (window.tidNotification) {
          tidNotification.show(BX.message('TID_ADDED_TO_COMPARE') || 'Товар добавлен к сравнению');
        }
      }
    );
  });

  // ════════════════════════════════════════════════════════
  // Add to Favorites (localStorage + AJAX)
  // ════════════════════════════════════════════════════════
  function updateFavText(btn, inWishlist) {
    var textSpan = btn.querySelector('.tid-product-info__action-text');
    if (!textSpan) return;
    var textFav = btn.getAttribute('data-text-fav') || 'В избранном';
    var origText = textSpan.getAttribute('data-orig-text');
    if (!origText) {
      origText = textSpan.textContent;
      textSpan.setAttribute('data-orig-text', origText);
    }
    textSpan.textContent = inWishlist ? textFav : origText;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-role="add-to-favorites"]');
    if (!btn) return;
    e.preventDefault();

    var productId = btn.dataset.id;
    if (!productId) return;

    // Получаем список избранного из localStorage
    var favorites = [];
    try {
      favorites = JSON.parse(localStorage.getItem('tid_favorites') || '[]');
    } catch(e) {}

    var index = favorites.indexOf(productId);
    if (index === -1) {
      favorites.push(productId);
      btn.classList.add('tid-product-info__action--active', 'tid-product-card__action--active');
      updateFavText(btn, true);

      if (window.tidNotification) {
        tidNotification.show(BX.message('TID_ADDED_TO_FAVORITES') || 'Товар добавлен в избранное');
      }
    } else {
      favorites.splice(index, 1);
      btn.classList.remove('tid-product-info__action--active', 'tid-product-card__action--active');
      updateFavText(btn, false);

      if (window.tidNotification) {
        tidNotification.show(BX.message('TID_REMOVED_FROM_FAVORITES') || 'Товар удалён из избранного');
      }
    }

    localStorage.setItem('tid_favorites', JSON.stringify(favorites));

    // Обновляем значок в хедере
    var favIcon = document.querySelector('.tid-header-action[href*="wishlist"] .tid-header-action__count');
    if (favIcon) {
      var count = favorites.length;
      if (count > 0) {
        favIcon.textContent = count;
        favIcon.style.display = '';
      } else {
        favIcon.style.display = 'none';
      }
    }
  });

  // ════════════════════════════════════════════════════════
  // Buy in 1 Click — Open Modal
  // ════════════════════════════════════════════════════════
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-role="buy-one-click"]');
    if (!btn) return;
    e.preventDefault();

    var productId = null;
    var productName = '';

    // Ищем ID товара — в этом же блоке или родительском контейнере
    var container = btn.closest('.tid-product-detail');
    if (!container) container = btn.closest('[data-entity="item"]');

    var idBtn = container ? container.querySelector('[data-role="add-to-cart"]') : null;
    productId = idBtn ? idBtn.dataset.id : null;

    var nameEl = container ? container.querySelector('h1, [itemprop="name"], .tid-product-card__name') : null;
    productName = nameEl ? (nameEl.textContent || nameEl.innerText).trim() : '';

    if (!productId) return;

    // Открываем модалку
    tidOpenBuyOneClickModal(productId, productName);
  });

  // ════════════════════════════════════════════════════════
  // Notification system
  // ════════════════════════════════════════════════════════
  window.tidNotification = {
    show: function(message) {
      var existing = document.querySelector('.tid-notification');
      if (existing) {
        existing.querySelector('.tid-notification__text').textContent = message;
        existing.classList.remove('tid-notification--hidden');
        return;
      }

      var notification = document.createElement('div');
      notification.className = 'tid-notification';
      notification.innerHTML =
        '<span class="tid-notification__text">' + BX.util.htmlspecialchars(message) + '</span>' +
        '<button class="tid-notification__close" data-role="notification-close">&times;</button>';

      document.body.appendChild(notification);

      // Закрытие по кнопке
      notification.querySelector('[data-role="notification-close"]').addEventListener('click', function() {
        notification.classList.add('tid-notification--hidden');
        setTimeout(function() { notification.remove(); }, 300);
      });

      // Авто-закрытие через 3 секунды
      setTimeout(function() {
        if (notification.parentNode) {
          notification.classList.add('tid-notification--hidden');
          setTimeout(function() { if (notification.parentNode) notification.remove(); }, 300);
        }
      }, 3000);
    }
  };

  // ════════════════════════════════════════════════════════
  // Close notification on click outside
  // ════════════════════════════════════════════════════════
  document.addEventListener('click', function(e) {
    var notif = document.querySelector('.tid-notification');
    if (notif && !notif.contains(e.target)) {
      notif.classList.add('tid-notification--hidden');
      setTimeout(function() { if (notif.parentNode) notif.remove(); }, 300);
    }
  });

  // ════════════════════════════════════════════════════════
  // Восстанавливаем состояние избранного из localStorage
  // ════════════════════════════════════════════════════════
  (function restoreFavoritesUI() {
    var favorites;
    try {
      favorites = JSON.parse(localStorage.getItem('tid_favorites') || '[]');
    } catch(e) { favorites = []; }

    if (favorites.length > 0) {
      // Подсвечиваем кнопки избранного
      document.querySelectorAll('[data-role="add-to-favorites"]').forEach(function(btn) {
        if (favorites.indexOf(btn.dataset.id) !== -1) {
          btn.classList.add('tid-product-info__action--active', 'tid-product-card__action--active');
          updateFavText(btn, true);
        }
      });

      // Обновляем бейдж в хедере
      var favIcon = document.querySelector('.tid-header-action[href*="wishlist"] .tid-header-action__count');
      if (favIcon) {
        favIcon.textContent = favorites.length;
        favIcon.style.display = '';
      }
    }
  })();

});

// ══════════════════════════════════════════════════════════
// Buy in 1 Click — Modal functions (outside tidReady)
// ══════════════════════════════════════════════════════════
function tidOpenBuyOneClickModal(productId, productName) {
  var overlay = document.querySelector('.tid-modal-overlay');
  if (!overlay) {
    // Создаём модалку, если её нет
    overlay = document.createElement('div');
    overlay.className = 'tid-modal-overlay';
    overlay.innerHTML =
      '<div class="tid-modal" data-role="buy-one-click-modal">' +
        '<button class="tid-modal__close" data-role="modal-close">&times;</button>' +
        '<div class="tid-modal__body">' +
          '<h3 class="tid-modal__title">Купить в 1 клик</h3>' +
          '<p class="tid-modal__product-name" data-role="modal-product-name"></p>' +
          '<form data-role="buy-one-click-form">' +
            '<input type="hidden" name="product_id" data-role="modal-product-id">' +
            '<div class="tid-form-group">' +
              '<label class="tid-form-label">Ваше имя</label>' +
              '<input type="text" name="name" class="tid-form-control" required placeholder="Введите имя">' +
            '</div>' +
            '<div class="tid-form-group">' +
              '<label class="tid-form-label">Телефон</label>' +
              '<input type="tel" name="phone" class="tid-form-control" required placeholder="+7 (___) ___-__-__">' +
            '</div>' +
            '<div class="tid-form-group">' +
              '<label class="tid-form-label">Email (необязательно)</label>' +
              '<input type="email" name="email" class="tid-form-control" placeholder="email@example.com">' +
            '</div>' +
            '<button type="submit" class="tid-btn tid-btn--primary tid-btn--lg tid-btn--block">' +
              'Отправить заказ' +
            '</button>' +
            '<div class="tid-modal__error" data-role="modal-error" style="display:none;color:red;margin-top:10px;"></div>' +
          '</form>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
  }

  // Заполняем данными
  overlay.querySelector('[data-role="modal-product-id"]').value = productId;
  overlay.querySelector('[data-role="modal-product-name"]').textContent = productName || '';
  overlay.querySelector('[data-role="modal-error"]').style.display = 'none';
  overlay.querySelector('[data-role="modal-error"]').textContent = '';

  // Показываем
  overlay.classList.add('tid-modal-overlay--open');
  document.body.classList.add('tid-body--modal-open');

  // Фокус на поле имени
  setTimeout(function() {
    var nameInput = overlay.querySelector('input[name="name"]');
    if (nameInput) nameInput.focus();
  }, 100);
}

// Закрытие модалки
document.addEventListener('click', function(e) {
  // По клику на overlay (вне модалки)
  var overlay = document.querySelector('.tid-modal-overlay');
  if (overlay && overlay.classList.contains('tid-modal-overlay--open')) {
    if (e.target === overlay) {
      overlay.classList.remove('tid-modal-overlay--open');
      document.body.classList.remove('tid-body--modal-open');
    }
  }

  // По кнопке закрытия
  var closeBtn = e.target.closest('[data-role="modal-close"]');
  if (closeBtn) {
    var modal = closeBtn.closest('.tid-modal-overlay');
    if (modal) {
      modal.classList.remove('tid-modal-overlay--open');
      document.body.classList.remove('tid-body--modal-open');
    }
  }
});

// Escape для закрытия модалки
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var overlayEl = document.querySelector('.tid-modal-overlay--open');
    if (overlayEl) {
      overlayEl.classList.remove('tid-modal-overlay--open');
      document.body.classList.remove('tid-body--modal-open');
    }
  }
});

// Отправка формы "Купить в 1 клик"
document.addEventListener('submit', function(e) {
  var form = e.target.closest('[data-role="buy-one-click-form"]');
  if (!form) return;
  e.preventDefault();

  var overlay = form.closest('.tid-modal-overlay');
  var submitBtn = form.querySelector('button[type="submit"]');
  var errorEl = form.querySelector('[data-role="modal-error"]');

  var name = form.querySelector('input[name="name"]').value.trim();
  var phone = form.querySelector('input[name="phone"]').value.trim();
  var email = form.querySelector('input[name="email"]').value.trim();
  var productId = form.querySelector('[data-role="modal-product-id"]').value;

  if (!name) {
    errorEl.textContent = 'Пожалуйста, введите имя';
    errorEl.style.display = '';
    return;
  }
  if (!phone) {
    errorEl.textContent = 'Пожалуйста, введите телефон';
    errorEl.style.display = '';
    return;
  }

  submitBtn.disabled = true;
  submitBtn.textContent = 'Отправка...';

  var ajaxUrl = (typeof SITE_DIR !== 'undefined' ? SITE_DIR : '/') + 'ajax/buy_one_click.php';

  BX.ajax.post(
    ajaxUrl,
    {
      product_id: productId,
      name: name,
      phone: phone,
      email: email,
      sessid: BX.bitrix_sessid()
    },
    function(result) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Отправить заказ';

      try {
        var data = JSON.parse(result);
        if (data.status === 'success') {
          // Закрываем модалку
          if (overlay) {
            overlay.classList.remove('tid-modal-overlay--open');
            document.body.classList.remove('tid-body--modal-open');
          }

          if (window.tidNotification) {
            tidNotification.show(data.message || 'Спасибо! Мы свяжемся с вами в ближайшее время.');
          }
        } else {
          errorEl.textContent = data.message || 'Произошла ошибка. Попробуйте позже.';
          errorEl.style.display = '';
        }
      } catch(e) {
        errorEl.textContent = 'Произошла ошибка. Попробуйте позже.';
        errorEl.style.display = '';
      }
    }
  );
});

// Копирование в буфер обмена (для бейджа с кодом товара)
function tidCopyToClipboard(el) {
  var text = el.textContent || el.innerText;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text.trim()).then(function() {
      var orig = el.textContent;
      el.textContent = 'Скопировано!';
      setTimeout(function() { el.textContent = orig; }, 1500);
    }).catch(function() {
      fallbackCopy(text, el);
    });
  } else {
    fallbackCopy(text, el);
  }
}

function fallbackCopy(text, el) {
  var ta = document.createElement('textarea');
  ta.value = text.trim();
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    var orig = el.textContent;
    el.textContent = 'Скопировано!';
    setTimeout(function() { el.textContent = orig; }, 1500);
  } catch(e) {}
  document.body.removeChild(ta);
}
